<template>
  <div class="warp warp_enterprise warp_zhapin" v-if="data">
    <Head></Head>
    <div class="modle_1" :style="'background: url('+data.img2+') center no-repeat;'">
      <div class="txt_box">
        <div class="t1">

          {{data.encatname}}
        </div>
        <div class="t2">
          {{data.catname}}
        </div>
        <div class="t3">

          {{data.seodescription}}
        </div>
      </div>
      <ChildBan></ChildBan>
    </div>




    <div class="modle_12">
      <div class="modle_14">
        <div class="t1" v-scroll-reveal>
          Recruitment information
        </div>
        <div class="t2" v-scroll-reveal>
          招募信息
        </div>
        <div class="t3" v-scroll-reveal>
          这是一个充满热情且积极乐观的年轻团队！能学习沉淀专业知识，优质的人脉资源，
          与优秀的人共事，环境让你变得更优秀！这里！最适合“正在奋斗着”的你！
          <br>
          {{datass.list[1].varvalue}}
          <br>
          {{datass.list[2].varvalue}}
        </div>
        <img src="/static/img/p14.png" v-scroll-reveal class="rit_erweima" />
      </div>
    </div>

    <div class="modle_15" v-if="data">

      <div class="item cle" v-for="(item,index) in data.list" :key="index">
        <div class="let fl">
          <div class="t1" v-scroll-reveal>
            {{item.catname}}
          </div>
          <div class="group">
            <ul>
              <li v-scroll-reveal v-for="(it,int) in item.list" :class="item.selint == int ? 'on' : ''" :key="int"
                @click="selIndex(index,int)">
                {{it.title}}
              </li>
              <!--  <li>
                推广实习生
              </li> -->
            </ul>
          </div>
        </div>

        <div class="rit fr">
          <div class="dm">


            <div class="it" v-scroll-reveal>
              <span>
                岗位名称
              </span>
              <div class="cn">
                {{item.list[item.selint].title}}
              </div>
            </div>

            <div class="it" v-scroll-reveal>
              <span>
                工作简述
              </span>
              <div class="cn" v-html="item.list[item.selint].introduce">

              </div>
            </div>

            <div class="it" v-scroll-reveal>
              <span>
                任职要求
              </span>
              <div class="cn" v-html="item.list[item.selint].content">
                推广实习生
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>

    <div class="map_list">

      <ul>
        <li v-scroll-reveal v-for="(item,index) in map_list" :key="index">
          <img :src="item.img1" style="width: 100%;" />
        </li>
      </ul>

    </div>






  </div>
</template>

<script>
  import {
    postrecruitAPI,
    postzpwzAPI,
    postconfigAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'

  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        sle_int: 0, //下表
        data: null, //案例信息
        map_list: [], //城市列表
        datass: null

      }
    },
    methods: {
      //获取案例信息
      getList() {
        var that = this;
        postrecruitAPI().then(function(res) {
          console.log(res);
          res.data.data.list.forEach(function(item, index) {
            item.selint = 0;
          })
          that.data = res.data.data;
          console.log(that.data);
        }).catch(function(err) {
          console.log(err);
        })

        postzpwzAPI().then(function(res) {
          that.map_list = res.data.data.list;
        }).catch(function(err) {
          console.log(err);
        })

      },
      //选择信息
      selIndex(pint, int) {
        var that = this;
        that.data.list[pint].selint = int;
        console.log(that.data);
      },
      //获取配置
      getConfigs() {
        var that = this
        postconfigAPI().then(function(res) {
          // console.log(res);
          that.datass = res.data.data;
          //  console.log(that.data);
        }).catch(function(err) {

        })
      },


    },
    mounted() {
      this.getList();
      this.getConfigs();

    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }

  @font-face {
    font-family: 'OPPOSans-L';
    src: url('../../../static/font/OPPOSans-L.ttf');
  }

  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
  }

  .warp_zhapin {
    font-family: 'OPPOSans-L';
    padding-bottom: 0px !important;
  }

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }

  .warp_enterprise {
    padding-bottom: 80px;
  }

  .modle_12 {}

  .modle_14 {
    padding: 0px 100px;
    padding-top: 140px;
    text-align: left;
    position: relative;
    background: #fafafa;
    padding-bottom: 160px;

    .t1 {
      color: #282828;
      font-size: 80px;

    }

    .t2 {
      color: #282828;
      font-size: 80px;
      margin-bottom: 100px;

    }

    .t3 {
      font-size: 24px;
      color: #282828;
      width: 60%;
    }

    .rit_erweima {
      position: absolute;
      right: 100px;
      top: 140px;
    }
  }

  .modle_15 {
    background: #fafafa;
    padding: 0px 100px;
    padding-bottom: 50px;

    .item {
      margin-bottom: 100px;

      .let {
        width: 30%;

        .t1 {
          color: #282828;
          font-size: 46px;
          border-bottom: 1px solid #000000;
          padding-bottom: 40px;
          margin-bottom: 40px;
          text-align: left;
        }

        .group {
          text-align: left;

          ul {
            li {
              border: 1px solid #fafafa;
              padding: 15px;
              background: url(/static/img/p15.png) 97% center no-repeat;
              margin-bottom: 10px;
              cursor: pointer;
            }

            .on {
              border: 1px solid rgba(0, 0, 0, 0.3);
            }

            li:hover {
              border: 1px solid rgba(0, 0, 0, 0.3);
            }
          }
        }
      }

      .rit {
        width: 68%;
        background: #fff;

        .dm {
          padding: 45px;
          text-align: left;

          .it {
            position: relative;
            margin-bottom: 75px;
            padding-left: 152px;


            span {
              font-size: 22px;
              color: #282828;
              display: inline-block;
              padding-right: 15px;
              position: absolute;
              top: 3px;
              left: 0px;
            }

            span::before {
              content: '';
              position: absolute;
              width: 5px;
              height: 5px;
              display: block;
              top: 50%;
              right: 0px;
              transform: translateY(-50%);
              background: #000000;
              border-radius: 50%;
            }

            .cn {
              font-size: 20px;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/recruit/recruit.vue